<template>
  <div v-if="logged" class="user-box">
    <template v-if="$store.getters.isLogined">
      <Dropdown trigger="click" placement="bottom-start">
        <div role="button" class="user-thumb">
          <Avatar v-if="userId" :uid="userId" :sex="$store.state.user.sex"></Avatar>
          <span class="username cell-text-ellipsis right" style="max-width: 130px;">{{ username }}</span>
        </div>
        <DropdownMenu slot="list">
          <DropdownItem  v-if="!isMobile()">
            <a :href="$ComDomain.Modules.usercenter">
              <template v-if="rolename == 'personal'">{{ navs.userMenu.personal }}</template>
              <template v-if="rolename == 'factory'">{{ navs.userMenu.factory }}</template>
              <template v-if="rolename == 'maintenance'">{{ navs.userMenu.maintenance }}</template>
            </a>
          </DropdownItem>
          <DropdownItem v-if="$store.getters.hasShop&&!isMobile()">
            <a :href="$ComDomain.Modules.space + $store.state.user.userId">{{ navs.userMenu.space }}</a>
          </DropdownItem>
          <DropdownItem v-if="$store.getters.hasShop&&!isMobile()">
            <a :href="$ComDomain.Modules.seller">{{ navs.userMenu.seller }}</a>
          </DropdownItem>
          <DropdownItem  v-if="!$store.getters.hasShop&&!isMobile()">
            <a href="javascript:void(0)" @click="$store.state.openShopModal = true">{{ navs.userMenu.shop }}</a>
          </DropdownItem>
          <DropdownItem v-if="!isMobile()">
            <a :href="$ComDomain.Modules.marketmsg">{{ navs.userMenu.message }}</a>
          </DropdownItem>
          <DropdownItem v-if="isMobile()">
            <a :href="$ComDomain.Modules.profileH5">{{ navs.userMenu.profile }}</a>
          </DropdownItem>
          <DropdownItem v-if="isMobile()">
            <a :href="$ComDomain.Modules.print3D">{{ navs.userMenu.print3D }}</a>
          </DropdownItem>
          <DropdownItem v-if="isMobile()">
            <a :href="$ComDomain.Modules.orderSimple">{{ navs.userMenu.order }}</a>
          </DropdownItem>
          <DropdownItem v-if="isMobile()">
            <a href="javascript:;" @click="$store.state.showInquiry=true">{{ navs.userMenu.inquiry }}</a>
          </DropdownItem>
          <DropdownItem v-if="isMobile()">
            <a @click="logoutH5">{{ navs.userMenu.logout }}</a>
          </DropdownItem>
          <DropdownItem v-else>
            <a @click="logout">{{ navs.userMenu.logout }}</a>
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
      <MessageTip v-if="(rolename == 'personal' || rolename == 'factory')&&!isMobile()"/>
    </template>
    <template v-else>
      <a class="high" role="button" @click="$store.commit('userEnter', {action: 'login'})">{{ actions.login }}</a> &nbsp;|&nbsp;
      <a class="high" role="button" @click="$store.commit('userEnter', {action: 'reg'})">{{ actions.reg }}</a>
    </template>
  </div>
</template>
<script>
  import {mapState} from 'vuex'
  import {Icon, Dropdown, DropdownMenu, DropdownItem} from 'iview'
  import {actions, navs} from '../../locale'
  import MessageTip from './MessageTip'
  import Avatar from '../Avatar'
  import {isMobile} from "plugins/Methods"

  export default {
    name : 'UserBox',
    data(){
      return {
        actions,
        navs,
        logged : false,
        isMobile
      }
    },
    computed : mapState({
      rolename : state => state.roleName,
      userId : state => state.user.userId,
      username : state => state.user.username || state.user.mobile
    }),
    methods : {
      logout(){
        this.$store.dispatch('logout').then(() => {
          if(!this.$route.meta.notRefresh){
            this.$router.push({name : 'refresh'})
          }
        })
      },
      logoutH5(){
        this.$store.dispatch('logout').then(() => {
          if(!this.$route.meta.notRefresh){
            this.$router.push({name : 'require'})
          }
        })
      }
    },
    components : {
      Icon,
      Dropdown,
      DropdownMenu,
      DropdownItem,
      MessageTip,
      Avatar
    },
    mounted(){
      this.logged = true
    }
  }

</script>
<style lang="less">
  .mobile .user-box  {
    .high{
      color: #ff8a00;
    }
    .user-thumb {
      .username {
        color: #ff8a00;
      }
    }
  }
</style>
<style scoped lang="less">
.user-box {
  .user-thumb {
    display: inline-block;
    line-height: 26px;
    text-align: center;

    img {
      width: 26px;
      height: 26px;
      vertical-align: middle;
    }

    i {
      width: 26px;
      color: #fff;
      font-size: 24px;
      vertical-align: middle;
      background: #c0c0c0;
    }

    .username {
      margin-left: .5em;
    }
  }

  .ivu-dropdown-item {
    padding: 0;
  }

  .ivu-dropdown-menu a {
    color: #141414;
    display: block;
    padding: 7px 16px;
    text-align: left;
  }

  a {
    color: #fff;
  }
}

</style>



// WEBPACK FOOTER //
// src/commons/components/layout/UserBox.vue